export default {"src":"/_next/static/media/search-icon.dbeb6262.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};